import { render, staticRenderFns } from "./order-display.vue?vue&type=template&id=7d1149c0&scoped=true"
import script from "./order-display.vue?vue&type=script&lang=js"
export * from "./order-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1149c0",
  null
  
)

export default component.exports